import React from 'react'

const Manual_cambiar_status_clau_invu = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Cambiar status de Clau.io a través de Invu
        </h2>
        <iframe
          src="https://scribehow.com/embed/Cambiar_status_de_Clau_io_a_traves_de_Invu__us5MTmEPT-Kq_vMv5O7Rmg?as=scrollable"
          className="scribe-iframe-general-69"
          width="100%"
          height="4600"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_cambiar_status_clau_invu
